import { Inject, Injectable } from '@angular/core';
import { map, from } from 'rxjs';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import * as i0 from "@angular/core";
export class AuthOktaService {
    constructor(oktaAuth) {
        this.oktaAuth = oktaAuth;
    }
    async isUserAuthenticated() {
        return await this.oktaAuth.isAuthenticated({ onExpiredToken: 'none' });
    }
    refreshAuthToken() {
        return this.getToken();
    }
    getAuthToken() {
        const accessToken = this.oktaAuth.getAccessToken();
        if (accessToken) {
            return accessToken;
        }
        return this.refreshAuthToken();
    }
    getToken() {
        return from(this.oktaAuth.tokenManager.get('accessToken')).pipe(map((token) => token?.accessToken));
    }
    static { this.ɵfac = function AuthOktaService_Factory(t) { return new (t || AuthOktaService)(i0.ɵɵinject(OKTA_AUTH)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AuthOktaService, factory: AuthOktaService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AuthOktaService, [{
        type: Injectable
    }], () => [{ type: OktaAuth, decorators: [{
                type: Inject,
                args: [OKTA_AUTH]
            }] }], null); })();
